import { DatePicker, DatePickerProps } from 'antd';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const Container = styled.div`
  @media (max-width: ${BREAKPOINTS.tabletMini}) {
    padding: 0 16px 0;

    .ant-row {
      margin-left: 0px !important;
      margin-right: 0px !important;
    }

    .ant-btn {
      display: flex;
      gap: 8px;
      justify-content: space-between;
      align-items: center;
    }

    .buttonCol {
      padding-left: 0 !important;
      padding-right: 0 !important;

      .ant-col {
        width: 100%;

        button {
          width: 100%;
        }
      }
    }
  }
`;

export const DatePickerFilter = styled(DatePicker)<DatePickerProps>`
  width: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .ant-form-item {
    margin-bottom: 0px;
  }
`;

export const FormUndertextContainer = styled.div`
  display: flex;
`;

export const FormUndertext = styled.h3`
  font-size: 0.625rem;
  font-weight: 400;
  color: #595959;
`;

export const ButtonText = styled.div`
  font-size: 0.875rem;
  font-weight: 400;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: none;
  }
`;
